module.exports = __webpack_public_path__ + "static/media/iconcustomreports.2d8711a9.svg";